"use client";

import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { makeRequest } from "../../../_config/api";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";

export default function LoginForm({ switchTab, onSuccess }) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!form.email) return showErrorToast("Email required");
    if (!form.password) return showErrorToast("Password required");

    try {
      setLoading(true);

      const res = await makeRequest("POST", "/user/login", {
        loginType: form.email,
        password: form.password,
      });

      if (!res.error) {
        const { token, ...user } = res.data;
        const expiresAt = Date.now() + 30 * 60 * 1000;

        localStorage.setItem("token", token);
        localStorage.setItem("tokenExpiry", expiresAt);
        localStorage.setItem("user", JSON.stringify(user));

        showSuccessToast("Login Successful 🚀");

        setForm({ email: "", password: "" });

        onSuccess?.();
        navigate("/dashboard");
      } else {
        showErrorToast(res.message || "Login failed");
      }
    } catch (err) {
      showErrorToast(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const forgotHandle = () => {
    switchTab("forgot");
  };

  return (
    <form className="space-y-3" onSubmit={handleLogin}>
      <ToastContainer />

      {/* Loader */}
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 flex flex-col items-center shadow-lg">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#132b45]"></div>
            <p className="mt-4 text-[#132e40] font-medium">Loading...</p>
          </div>
        </div>
      )}

      <label className="block font-medium text-[#162e40]">Email</label>
      <input
        type="email"
        name="email"
        placeholder="Enter your email"
        value={form.email}
        onChange={handleChange}
        className="w-full p-3 border rounded-md"
      />

      <label className="block font-medium text-[#162e40]">Password</label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Enter Password"
          value={form.password}
          onChange={handleChange}
          className="w-full p-3 border rounded-md"
        />
        <span
          className="absolute right-4 top-4 cursor-pointer"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <FiEyeOff /> : <FiEye />}
        </span>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 mt-4 bg-[#162e40] text-white rounded-md"
      >
        {loading ? "Logging in..." : "Login"}
      </button>

      <p className="text-center mt-4 text-[#162e40]">
        Forgot Password?{" "}
        <span className="cursor-pointer font-bold underline" onClick={forgotHandle}>
          Click Here
        </span>
      </p>
    </form>
  );
}
